/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Guides_Formulas_TitleInputs */

const en_gc_guides_formulas_title = /** @type {(inputs: Gc_Guides_Formulas_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GridCraft formulas: a practical SUM and IF tutorial`)
};

const zh_gc_guides_formulas_title = /** @type {(inputs: Gc_Guides_Formulas_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GridCraft 公式教程：实用的 SUM 与 IF 入门`)
};

/**
* | output |
* | --- |
* | "GridCraft formulas: a practical SUM and IF tutorial" |
*
* @param {Gc_Guides_Formulas_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_guides_formulas_title = /** @type {((inputs?: Gc_Guides_Formulas_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Guides_Formulas_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_guides_formulas_title(inputs)
	return zh_gc_guides_formulas_title(inputs)
});
export { gc_guides_formulas_title as "gc.guides.formulas.title" }